import { translate } from '../../../../utils/i18n';
import DuoChatMessage from '../duo_chat_message/duo_chat_message';
import DuoChatMessageToolApproval from '../duo_chat_message_tool_approval/message_tool_approval';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  CONVERSATION_NEW_CHAT: translate('DuoChatConversation.newChat', 'New chat')
};
const isMessage = item => Boolean(item) && (item === null || item === void 0 ? void 0 : item.role);

// eslint-disable-next-line unicorn/no-array-callback-reference
const itemsValidator = items => items.every(isMessage);
var script = {
  name: 'DuoChatConversation',
  components: {
    DuoChatMessage,
    DuoChatMessageToolApproval
  },
  props: {
    /**
     * Messages to display
     */
    messages: {
      type: Array,
      required: false,
      default: () => [],
      validator: itemsValidator
    },
    canceledRequestIds: {
      type: Array,
      required: false,
      default: () => []
    },
    /**
     * Whether the insertCode feature should be available.
     */
    enableCodeInsertion: {
      type: Boolean,
      required: true
    },
    /**
     * Whether to show the delimiter before this conversation
     */
    showDelimiter: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Base URL of the GitLab instance.
     */
    trustedUrls: {
      type: Array,
      required: false,
      default: () => []
    },
    /**
     * Whether the chat should show the feedback link on the assistant messages.
     */
    withFeedback: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Whether the tool call is currently being processed.
     */
    isToolApprovalProcessing: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Optional parameter to pass in the working directory - needed for MessageMap Tool type
     */
    workingDirectory: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    /**
     * Checks if the last message in the conversation is a tool approval request
     * @returns {boolean} True if last message is awaiting tool approval
     */
    isLastMessageToolApproval() {
      const lastMsg = this.messages[this.messages.length - 1];
      return (lastMsg === null || lastMsg === void 0 ? void 0 : lastMsg.message_type) === 'request' && Boolean(lastMsg === null || lastMsg === void 0 ? void 0 : lastMsg.tool_info);
    },
    /**
     * Collects all consecutive tool approval requests at the end of the messages array.
     * @returns {Array} Array of all pending tool approval requests
     */
    pendingToolApprovals() {
      // Early return if last message isn't a tool request
      if (!this.isLastMessageToolApproval) {
        return [];
      }

      // Find the last non-tool message
      const lastNonToolIndex = this.messages.findLastIndex(msg => msg.message_type !== 'request' || !msg.tool_info);

      // Slice from after the last non-tool message to the end
      return this.messages.slice(lastNonToolIndex + 1);
    },
    hasPendingToolApprovals() {
      return this.pendingToolApprovals.length > 0;
    },
    toolApprovalOptions() {
      var _this$pendingToolAppr;
      const lastIndex = this.pendingToolApprovals.length - 1;
      return (_this$pendingToolAppr = this.pendingToolApprovals[lastIndex]) === null || _this$pendingToolAppr === void 0 ? void 0 : _this$pendingToolAppr.approvalOptions;
    }
  },
  methods: {
    onTrackFeedback(event) {
      /**
       * Notify listeners about the feedback form submission on a response message.
       * @param {*} event An event, containing the feedback choices and the extended feedback text.
       */
      this.$emit('track-feedback', event);
    },
    onInsertCodeSnippet(e) {
      this.$emit('insert-code-snippet', e);
    },
    onCopyCodeSnippet(e) {
      this.$emit('copy-code-snippet', e);
    },
    onCopyMessage(e) {
      this.$emit('copy-message', e);
    },
    onGetContextItemContent(e) {
      this.$emit('get-context-item-content', e);
    },
    onOpenFilePath(e) {
      this.$emit('open-file-path', e);
    },
    onApproveToolCall(approvalPayload) {
      this.$emit('approve-tool', approvalPayload);
    },
    onDenyToolCall(reason) {
      this.$emit('deny-tool', reason);
    }
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'gl-flex gl-flex-col gl-justify-end gl-gap-6',
    { 'insert-code-hidden': !_vm.enableCodeInsertion } ]},[(_vm.showDelimiter)?_c('div',{staticClass:"gl-my-5 gl-flex gl-items-center gl-gap-4 gl-text-gray-500",attrs:{"data-testid":"conversation-delimiter"}},[_c('hr',{staticClass:"gl-grow"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$options.i18n.CONVERSATION_NEW_CHAT))]),_vm._v(" "),_c('hr',{staticClass:"gl-grow"})]):_vm._e(),_vm._v(" "),_vm._l((_vm.messages),function(msg,index){return _c('duo-chat-message',{key:((msg.role) + "-" + index),attrs:{"message":msg,"trusted-urls":_vm.trustedUrls,"is-cancelled":_vm.canceledRequestIds.includes(msg.requestId),"with-feedback":_vm.withFeedback,"working-directory":_vm.workingDirectory},on:{"track-feedback":_vm.onTrackFeedback,"insert-code-snippet":_vm.onInsertCodeSnippet,"copy-code-snippet":_vm.onCopyCodeSnippet,"copy-message":_vm.onCopyMessage,"get-context-item-content":_vm.onGetContextItemContent,"open-file-path":_vm.onOpenFilePath}})}),_vm._v(" "),(_vm.hasPendingToolApprovals)?_c('duo-chat-message-tool-approval',{attrs:{"messages":_vm.pendingToolApprovals,"is-processing":_vm.isToolApprovalProcessing,"approval-options":_vm.toolApprovalOptions},on:{"approve-tool":_vm.onApproveToolCall,"deny-tool":_vm.onDenyToolCall}}):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
